import { useCallback, useEffect, useRef, useState } from 'react';
import type { ReleaseVersion } from '../../models/Release/releaseVersions';
import { releaseApi } from '../../services/releaseApi';

export const useReleaseHistory = () => {
  const [versions, setVersions] = useState<readonly ReleaseVersion[]>([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const request = useRef<AbortController | null>(null);

  const reload = useCallback(async () => {
    request.current?.abort();
    const controller = new AbortController();
    request.current = controller;
    setLoading(true);
    setFailed(false);
    try {
      const result = await releaseApi.getVersions(controller.signal);
      if (!controller.signal.aborted) setVersions(result);
    } catch {
      if (!controller.signal.aborted) setFailed(true);
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
    return () => request.current?.abort();
  }, [reload]);

  return { versions, loading, failed, reload };
};
